<div class="asset-section">
	<div class="section-title">Mechanical Diagnostics</div>
	@if (components) {
	<div class="group-list">
		@if (components.engine && components.engine.length) {
		<div class="panel group">
			<div class="heading" [class.selected]="selectedcomponent?.type === 'engine'">Engine</div>
			<div class="content">
				@for (engine of components.engine; track engine) {
				<i [routerLink]="getComponentRouterLink(engine.id)" routerLinkActive="selected" [class]="ItemHealth.GetForegroundColor(engine.state?.filtered_hi)" class="icon-motor"
					title="{{engine.name}} ({{engine.id}}) {{lookupLRU(engine)}}"></i>
				}
			</div>
		</div>
		}
		@if (components.tach && components.tach.length) {
		<div class="panel group">
			<div class="heading" [class.selected]="selectedcomponent?.type === 'tach'">Tach</div>
			<div class="content">
				@for (tach of components.tach; track tach) {
				<i [routerLink]="getComponentRouterLink(tach.id)" routerLinkActive="selected" [class]="ItemHealth.GetForegroundColor(tach.state?.filtered_hi)" class="icon-gauge"
					title="{{tach.name}} ({{tach.id}}) {{lookupLRU(tach)}}"></i>
				}
			</div>
		</div>
		}
		@for (shaft of components.shaft | isnotghost; track shaft) {
		<div class="panel group">
			<div class="heading" [class.selected]="selectedcomponent === shaft || selectedshaft === shaft">
				{{shaft.name}}</div>
			<div class="content">
				<i [routerLink]="getComponentRouterLink(shaft.id)" routerLinkActive="selected" [class]="ItemHealth.GetForegroundColor(shaft.state?.filtered_hi)" class="icon-shaft"
					title="{{shaft.name}} ({{shaft.id}}) {{lookupLRU(shaft)}}"></i>
				@for (gear of shaft.gear; track gear) {
				<i [routerLink]="getComponentRouterLink(gear.id)" routerLinkActive="selected" [class]="ItemHealth.GetForegroundColor(gear.state?.filtered_hi)" class="icon-cog"
					title="{{gear.name}} ({{gear.id}}) {{lookupLRU(gear)}}"></i>
				}
				@for (bearing of shaft.bearing; track bearing) {
				<i [routerLink]="getComponentRouterLink(bearing.id)" routerLinkActive="selected" [class]="ItemHealth.GetForegroundColor(bearing.state?.filtered_hi)" class="icon-bearing"
					title="{{bearing.name}} ({{bearing.id}}) {{lookupLRU(bearing)}}"></i>
				}
			</div>
		</div>
		}
		@if (components.flutter && components.flutter.length) {
		<div class="panel group">
			<div class="heading" [class.selected]="selectedcomponent?.type === 'flutter'">Flutter</div>
			<div class="content">
				@for (flutter of components.flutter; track flutter) {
				<i [routerLink]="getComponentRouterLink(flutter.id)" routerLinkActive="selected" [class]="ItemHealth.GetForegroundColor(flutter.state?.filtered_hi)" class="icon-flutter"
					title="{{flutter.name}} ({{flutter.id}}) {{lookupLRU(flutter)}}"></i>
				}
			</div>
		</div>
		}
		@if (components.tracker && components.tracker.length) {
		<div class="panel group">
			<div class="heading" [class.selected]="selectedcomponent?.type === 'tracker'">Trackers</div>
			<div class="content">
				@for (tracker of components.tracker; track tracker) {
				<i [routerLink]="getComponentRouterLink(tracker.id)" routerLinkActive="selected" [class]="ItemHealth.GetForegroundColor(tracker.state?.filtered_hi)" class="icon-camera"
					title="{{tracker.name}} ({{tracker.id}}) {{lookupLRU(tracker)}}"></i>
				}
			</div>
		</div>
		}
		@if (components.sensor && components.sensor.length) {
		<div class="panel group">
			<div class="heading" [class.selected]="selectedcomponent?.type === 'sensor'">Sensors</div>
			<div class="content">
				@for (sensor of components.sensor; track sensor) {
				<i [routerLink]="getComponentRouterLink(sensor.id)" routerLinkActive="selected" [class]="ItemHealth.GetForegroundColor(sensor.state?.filtered_hi)" class="icon-sensor"
					title="{{sensor.name}} ({{sensor.id}}) {{lookupLRU(sensor)}}"></i>
				}
			</div>
		</div>
		}
		<div class="panel group">
			<div class="heading" [class.selected]="selectedmaintenance">Maintenance</div>
			<div class="content">
				@if (!asset.is_fixed && components.alt_engine_name && (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master')) {
				<i routerLink="engine" routerLinkActive="selected" class="icon-motor" title="Engine maintenance"></i>
				}
				<i routerLink="maintenance-log" routerLinkActive="selected" class="icon-calendar" title="Maintenance log"></i>
				@if (!asset.is_fixed) {
				<i routerLink="firmware" routerLinkActive="selected" class="icon-search" title="Firmware"></i>
				}
				<i routerLink="alerts" routerLinkActive="selected" [class]="ItemHealth.GetForegroundColor(asset.alertcount ? 1 : (asset.alertcount === 0 ? 0 : undefined))"
					class="icon-attention" title="Alert log"></i>
				@if (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') {
				<i routerLink="connections" routerLinkActive="selected" class="icon-doc" title="Connection log" class="icon-doc" title="Connection log"></i>
				}
				@if (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') {
				<i routerLink="user-access" routerLinkActive="selected" class="icon-users" title="User access"></i>
				}
				<!-- TODO: temporarily turning off OBCU log for regular users -->
				@if (api.user.role === 'admin' || api.user.role === 'master') {
				<i routerLink="comm-failures" routerLinkActive="selected"
					[class]="ItemHealth.GetForegroundColor(asset.latest_obcu_failures > 0 ? 1 : (asset.latest_assembly_version ? 0 : undefined))" class="icon-link"
					title="Sensor failures"></i>
				}
			</div>
		</div>
	</div>
	}
	<div #routerContent class="router-content">
		@if (components) {
		<router-outlet (activate)="updateRouterOutlet($event)"></router-outlet>
		}
	</div>
</div>